export default "__VITE_ASSET__LvMhTgSA__"